export default __webpack_public_path__ + "static/media/Q12_1_resized.6d73d7b1.jpg";